// components/common/Button/SaveButton.tsx
import React from "react";
import { Button as AntButton, ButtonProps } from "antd";
import styles from "./Button.module.css";

type SaveButtonProps = Omit<ButtonProps, "type"> & {
    saving?: boolean;
};

export const NSPButton = ({
    saving = false,
    children = "Save Changes",
    ...props
}: SaveButtonProps) => {
    return (
        <AntButton
            type="primary"
            loading={saving}
            className={styles.saveButton}
            {...props}
        >
            {saving ? "Saving..." : children}
        </AntButton>
    );
};
